export const SET_CURRENT_QUEUE_DEAL_ID = 'set-current-queue-deal_id';
export const SET_DEAL_QUEUE = 'set-deal-queue';
export const SET_GAME_OPTIONS = 'set-game-options';
